import { OTPInput, OTPInputContext } from 'input-otp'
import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

const InputOTP = ({
	className,
	containerClassName,
	...props
}: React.ComponentProps<typeof OTPInput>) => (
	<OTPInput
		inputMode="text"
		data-slot="input-otp"
		containerClassName={cn(
			'group/otp flex items-center gap-1.5 has-disabled:opacity-50',
			containerClassName,
		)}
		className={cn('disabled:cursor-not-allowed', className)}
		{...props}
	/>
)

const InputOTPGroup = ({
	className,
	...props
}: React.ComponentProps<'div'>) => (
	<div
		data-slot="input-otp-group"
		className={cn('flex items-center', className)}
		{...props}
	/>
)

const InputOTPSlot = ({
	index,
	className,
	...props
}: React.ComponentProps<'div'> & {
	index: number
}) => {
	const inputOTPContext = React.useContext(OTPInputContext)
	const slot = inputOTPContext.slots[index]
	if (!slot) throw new Error('Invalid slot index')
	const { char, hasFakeCaret, isActive } = slot

	return (
		<div
			data-slot="input-otp-slot"
			data-active={isActive || undefined}
			className={cn(
				// `aria-invalid` lands on the hidden input, not on the slots, so the
				// slots read it off the container. The active ring marks where the
				// next character goes; it is a state ring, not a focus indicator.
				'bg-control-glass border-input text-body-sm data-[active]:ring-ring group-has-[[aria-invalid=true]]/otp:border-input-invalid relative flex size-10 items-center justify-center border-y border-r font-mono transition-all first:rounded-l-xl first:border-l last:rounded-r-xl data-[active]:z-10 data-[active]:ring-2',
				className,
			)}
			{...props}
		>
			{char}
			{hasFakeCaret && (
				<div className="pointer-events-none absolute inset-0 flex items-center justify-center">
					<div className="animate-caret-blink bg-foreground h-4 w-px duration-1000" />
				</div>
			)}
		</div>
	)
}

const InputOTPSeparator = (props: React.ComponentProps<'div'>) => (
	<div
		data-slot="input-otp-separator"
		className="bg-border h-0.5 w-2.5 rounded-full"
		{...props}
	/>
)

export { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSeparator }
